import { render, staticRenderFns } from "./BunkeringLogDetail.vue?vue&type=template&id=9e0c36ac&scoped=true"
import script from "./BunkeringLogDetail.vue?vue&type=script&lang=js"
export * from "./BunkeringLogDetail.vue?vue&type=script&lang=js"
import style0 from "./BunkeringLogDetail.vue?vue&type=style&index=0&id=9e0c36ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e0c36ac",
  null
  
)

export default component.exports